module.exports = __webpack_public_path__ + "img/pingduCode.75e61139.png";